<script setup lang="ts">
import {
  DateRangePicker,
  formatDateRangeShort,
  getComparisonRange,
  SegmentedFilter,
  TRAFFIC_SOURCE_FILTER_ITEMS,
  TypographyComponent,
} from '@metapic-apps/shared'
import { computed } from 'vue'

import { useGlobalFilterStore } from '@/stores/global-filter.stores'

const filterStore = useGlobalFilterStore()
const comparedToLabel = computed(() => {
  const range = filterStore.dateRange
  if (!range?.startDate || !range?.endDate) {
    return ''
  }
  const { from, to } = getComparisonRange(range.startDate, range.endDate)
  return formatDateRangeShort(from, to)
})
</script>
<template>
  <div class="performance-filter">
    <SegmentedFilter
      :model-value="filterStore.trafficSource"
      :items="TRAFFIC_SOURCE_FILTER_ITEMS"
      :max="4"
      aria-label="Traffic source"
      @update:model-value="filterStore.setTrafficSource"
    />
    <div class="performance-filter__date">
      <DateRangePicker :model-value="filterStore.dateRange" borderless @update:model-value="filterStore.setDateRange" />
      <TypographyComponent v-if="comparedToLabel" variant="body-extra-small" font-style="italic" class="performance-filter__compared"
        >Compared to: {{ comparedToLabel }}</TypographyComponent
      >
    </div>
  </div>
</template>
<style scoped lang="scss">
.performance-filter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.performance-filter__date {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 16px;
}
.performance-filter__compared {
  opacity: 0.32;
  white-space: nowrap;
}
</style>
